import { LoadingButton } from '@mui/lab';
import { ActionMakePrepaid } from '_models/redux/makePrepaid/action';
import { cleanMakePrepaid } from '_models/redux/makePrepaid/clean-action';
import { ActionProductPrepaid } from '_models/redux/products_prepaid/action';
import { listcommentsTikets } from '_models/redux/request-list-comments/action';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import { ActionMakePrepaidHooks } from '../hooks/actionsTicketsHooks/ActionMakePrepaidHooks';
import CustomComponenteMakePrepaid from './CustomComponenteMakePrepaid';

const MakePrepaid = (props) => {
  const {
    ticketId,
    ActionProductPrepaid,
    productsPrepaid,
    ActionMakePrepaid,
    cleanMakePrepaid,
    makePrepaid,
    listcommentsTikets,
  } = props;

  const { handleMakePrepaid, isDialogOpenMakePrepaid, setIsDialogOpenMakePrepaid } =
    ActionMakePrepaidHooks();
  const [hasAppliedRecharge, setHasAppliedRecharge] = useState(false);
  const [isExitConfirmOpen, setIsExitConfirmOpen] = useState(false);
  const formDraftRef = useRef({
    product_id: '',
    is_paid: '',
    reason: '',
  });

  const closeMainDialog = () => {
    cleanMakePrepaid();
    setIsDialogOpenMakePrepaid(false);
    formDraftRef.current = {
      product_id: '',
      is_paid: '',
      reason: '',
    };
  };

  const handleRequestClose = () => {
    if (hasAppliedRecharge) {
      closeMainDialog();
      return;
    }
    setIsExitConfirmOpen(true);
  };

  const handleOpenMakePrepaid = () => {
    cleanMakePrepaid();
    setHasAppliedRecharge(false);
    setIsExitConfirmOpen(false);
    formDraftRef.current = {
      product_id: '',
      is_paid: '',
      reason: '',
    };
    handleMakePrepaid();
  };

  useEffect(() => {
    ActionProductPrepaid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const responseStatus = Number(makePrepaid?.status ?? makePrepaid?.payload?.response?.status);
    if (responseStatus >= 200 && responseStatus < 300) {
      setHasAppliedRecharge(true);
    }
  }, [makePrepaid]);

  return (
    <>
      <LoadingButton
        fullWidth
        property='textAlign'
        size='small'
        onClick={handleOpenMakePrepaid}
        variant='outlined'
        className='button'
      >
        <h4>Aplicar paquete</h4>
      </LoadingButton>
      <CustomDialog
        title='Aplicar paquete'
        content={
          <CustomComponenteMakePrepaid
            listcommentsTikets={listcommentsTikets}
            makePrepaid={makePrepaid}
            ticketId={ticketId}
            ActionMakePrepaid={ActionMakePrepaid}
            productsPrepaid={productsPrepaid}
            ActionProductPrepaid={ActionProductPrepaid}
            formData={formDraftRef.current}
            onFormDataChange={(changes) => {
              formDraftRef.current = {
                ...formDraftRef.current,
                ...changes,
              };
            }}
          />
        }
        onClose={handleRequestClose}
        open={isDialogOpenMakePrepaid}
        fullWidth
        maxWidth=''
        showCloseButton={false}
        extraButtons={[
          {
            label: 'Cerrar',
            variant: 'contained',
            onClick: handleRequestClose,
            buttonColor: '#724ECB',
            textColor: 'white',
          },
        ]}
      />
      <CustomDialog
        title='Confirmar salida'
        content='Estas apunto de salir sin haber aplicado ninguna recarga, ¿Deseas salir sin recargar?'
        onClose={() => setIsExitConfirmOpen(false)}
        open={isExitConfirmOpen}
        fullWidth
        maxWidth='xs'
        showCloseButton={false}
        extraButtons={[
          {
            label: 'No, regresar a aplicar recarga',
            variant: 'outlined',
            onClick: () => setIsExitConfirmOpen(false),
            buttonColor: 'transparent',
            textColor: '#724ECB',
          },
          {
            label: 'Si, salir',
            variant: 'contained',
            onClick: () => {
              setIsExitConfirmOpen(false);
              closeMainDialog();
            },
            buttonColor: '#724ECB',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  makePrepaid: state.makePrepaid,
  productsPrepaid: state.productsPrepaid,
});
const mapDispatchToProps = {
  ActionMakePrepaid,
  cleanMakePrepaid,
  ActionProductPrepaid,
  listcommentsTikets,
};

export default connect(mapStateToProps, mapDispatchToProps)(MakePrepaid);
